import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { SpinnerComponent } from '../spinner-component/SpinnerComponent';
import _ from 'lodash';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';

export const ValidationErrorsComponent = ({ isLoading, errors = [], loadingError = null, submitStatus = '' }) => {
  const {
    SYNC_STATUS_MESSAGE_VALIDATION_RESPONSE: { SUCCESSFUL, SUCCESS }
  } = CCMClientSettingsConfig;
  const [isOpen, setIsOpen] = useState(true);
  const renderLoadingError = () => <p className="text-alert-primary">{loadingError}</p>;

  const renderSpinner = () => (
    <div className="flex flex-row">
      <div>This client has been submitted and we're waiting on it to process. Checking again... </div>
      <SpinnerComponent />
    </div>
  );

  const renderValidationErrors = () => (
    <details className="collapse bg-base-200" open={isOpen} onClick={() => setIsOpen(!isOpen)}>
      <summary className="collapse-title font-medium"> Validation Errors</summary>
      <div className="collapse-content">
        {errors.map(({ type, field, description }, index) => (
          <Error key={index} type={type} field={field} description={description} />
        ))}
      </div>
    </details>
  );

  const renderSuccessMessage = () => (
    <div className="flex flex-row">
      <span className="font-medium text-success-primary">Last submission was processed successfully</span>
    </div>
  );

  return (
    <div className={classNames(styles.errorsContainer)}>
      {_.isNil(loadingError)
        ? isLoading
          ? renderSpinner()
          : !_.isNil(errors) && errors.length > 0
          ? renderValidationErrors()
          : [SUCCESSFUL, SUCCESS].includes(submitStatus)
          ? renderSuccessMessage()
          : null
        : renderLoadingError()}
    </div>
  );
};

const Error = ({ type, field, description }) => (
  <div className={classNames(styles.errorInfo)}>
    <div>
      Type: <span className="text-alert-primary">{type}</span>
    </div>
    <div>
      Field: <span className="text-alert-primary">{field}</span>
    </div>
    <div>
      Description: <span className="text-alert-primary">{description}</span>
    </div>
  </div>
);
